import { API } from "./api";

export const askQuestion = async (data, config = {}) =>
  API.post("/user-requests/ask-question", data, { ...config });

export const generateUser = async (data, config = {}) =>
  API.post("/users", data, { ...config });

export const updateUser = async (userId, data, config = {}) =>
  API.put(`/users/${userId}`, data, { ...config });

export const generateParticipant = async (data, config = {}) =>
  API.post("/participants", data, { ...config });

export const updateParticipant = async (userId, data, config = {}) =>
  API.put(`/participants/${userId}`, data, { ...config });
